import axiosInstance from './AxiosInstance';

const MenuService = {
  // Public: Get menu for a role
  getMenuByRole: async (roleCode) => {
    try {
      const response = await axiosInstance.get(`/menu-configuration/role/${roleCode}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Management: CRUD menu items
  getAllItems: async () => {
    try {
      const response = await axiosInstance.get('/menu-configuration/items');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getItem: async (id) => {
    try {
      const response = await axiosInstance.get(`/menu-configuration/items/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  createItem: async (payload) => {
    try {
      const response = await axiosInstance.post('/menu-configuration/items', payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  updateItem: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/menu-configuration/items/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  deleteItem: async (id) => {
    try {
      const response = await axiosInstance.delete(`/menu-configuration/items/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Role assignments
  getAssignments: async (menuId) => {
    try {
      const response = await axiosInstance.get(`/menu-configuration/items/${menuId}/roles`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  assignRole: async (payload) => {
    try {
      const response = await axiosInstance.post('/menu-configuration/assignments', payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  updateAssignment: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/menu-configuration/assignments/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  removeAssignment: async (id) => {
    try {
      const response = await axiosInstance.delete(`/menu-configuration/assignments/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get parent menus
  getParentMenus: async () => {
    try {
      const response = await axiosInstance.get('/menu-configuration/parent-menus');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default MenuService;
